import React from "react"




function Home() {
    return (
        <div className="home-page">
           <h1>SMOOVIES</h1>
           <h2>The new Media Picker</h2>
           <h4>What are we watching today ?</h4>
        </div>
    )
}

export default Home
